export const IconPix = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="m15.454 16.53-3.017-3.017a.44.44 0 0 0-.31-.13c-.07 0-.2.02-.31.13L8.79 16.539c-.34.34-.872.892-2.645.892l3.717 3.708a3.006 3.006 0 0 0 4.249 0l3.727-3.718c-.911 0-1.673-.18-2.384-.892M8.79 7.46l3.026 3.027c.08.08.2.13.31.13.111 0 .231-.05.311-.13l2.997-2.996c.711-.742 1.523-.912 2.435-.912L14.14 2.86a3.006 3.006 0 0 0-4.249 0L6.175 6.57c1.763 0 2.304.581 2.615.892" />
      <path d="M21.125 9.845 18.87 7.581h-1.262c-.541 0-1.083.22-1.453.611l-3.007 3.006c-.28.28-.65.421-1.022.421a1.5 1.5 0 0 1-1.022-.42L8.078 8.161a2.06 2.06 0 0 0-1.453-.601H5.152L2.857 9.865a3.006 3.006 0 0 0 0 4.25l2.295 2.304h1.483a2.1 2.1 0 0 0 1.453-.601l3.026-3.027c.28-.28.652-.42 1.022-.42.371 0 .742.14 1.023.42l3.016 3.017c.38.38.901.6 1.453.6h1.262l2.255-2.264a3.05 3.05 0 0 0-.02-4.299" />
    </svg>
  );
};
